<app-ui-main-menu>
    <mat-card>
        <mat-card-header>
            <mat-card-title>Cadastro de Oportunidade</mat-card-title>
        </mat-card-header>

        <mat-divider></mat-divider>

        <ng-container *ngIf="!loadingEditMode; else loading">
            <mat-card-content>
                <form [formGroup]="leadForm">
                    <div class="patient-details">
                        <div class="col-12 d-flex flex-column">
                            <ng-container>
                                <h3>Dados do paciente</h3>
                            </ng-container>
                            
                            <div class="col-12 d-flex flex-column flex-lg-row" style="gap: 20px">
                                <div class="col-7 col-xl-3 col-lg-5 col-md-5">
                                    <mat-form-field appearance="outline">
                                        <mat-label>Nome Completo</mat-label>
                                        <input matInput type="text" formControlName="name">
    
                                        <mat-error *ngIf="leadForm.get('name')?.hasError('required')">
                                            Nome do paciente é obrigatório
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                                <div class="col-7 col-xl-2 col-lg-3 col-md-5">
                                    <mat-form-field appearance="outline">
                                        <mat-label>CPF</mat-label>
                                        <input 
                                            matInput 
                                            type="text" 
                                            formControlName="document" 
                                            [specialCharacters]="['/', '.', '-']" 
                                            [mask]="'000.000.000-00'" 
                                            (change)="onChangeCPF()"
                                        >
                                        <mat-error *ngIf="leadForm.get('document').hasError('invalid')">
                                            CPF inválido
                                        </mat-error> 
                                    </mat-form-field>
                                </div>
                            </div> 
    
                            <div class="col-12 d-flex flex-column flex-lg-row" style="gap: 20px">
                                <div class="col-7 col-xl-2 col-lg-3 col-md-5">
                                    <mat-form-field appearance="outline" >
                                        <mat-label>Estado</mat-label>
                                        <mat-select formControlName ="state">
                                            <mat-option 
                                                *ngFor="let state of brazilStates" 
                                                [value]="state.sigla"
                                            >
                                                {{state.nome}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
    
                                <div class="col-7 col-xl-2 col-lg-3 col-md-5">
                                    <mat-form-field appearance="outline">
                                        <mat-label>Cidade</mat-label>
                                        <input type="text"
                                            matInput
                                            placeholder="Procurar cidade..."
                                            [matAutocomplete]="auto"
                                            formControlName="city"
                                            [disabled]="!brazilStateCities.length"
                                        >

                                        <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete"
                                            (optionSelected)="onCitySelected($event.option.value)" 
                                        >
                                            <mat-option
                                                *ngFor="let city of citiesFiltered$ | async"
                                                [value]="city.nome"
                                            >
                                                {{city.nome}}
                                            </mat-option>
    
                                            <mat-option *ngIf="!(citiesFiltered$ | async)?.length" disabled>
                                                Nenhuma cidade encontrada
                                            </mat-option>
                                        </mat-autocomplete>

                                        <mat-error *ngIf="leadForm.get('city')?.hasError('invalid')">
                                            Informe o nome da cidade corretamente.
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                        <div class="patient-contact">
                            
                            <ng-container>
                                <h3>Contato</h3>
                            </ng-container>
    
                            <div formArrayName="contacts">
                                <div *ngFor="let contactGroup of contactsFormArray.controls; let i = index" [formGroupName]="i" class="contact">
                                    
                                    <div class="col-12 d-flex flex-column flex-lg-row" style="gap:20px">
                                        <div class="col-7 col-xl-2 col-md-5">
                                            <mat-form-field appearance="outline"> 
                                            <mat-label>Contato</mat-label>
    
                                            <mat-select formControlName="contactMethod" *ngIf="i < 1" >
                                                <mat-option *ngFor="let method of primaryContact" [value]="method">{{ method }}</mat-option>
                                            </mat-select>
    
                                            <mat-select formControlName="contactMethod" *ngIf="i >= 1" >
                                                <mat-option *ngFor="let method of contactType" [value]="method">{{ method }}</mat-option>
                                            </mat-select>
    
                                            <mat-error *ngIf="contactGroup.get('contactMethod')?.hasError('required')">
                                                Forma de contato é obrigatória
                                            </mat-error>
                                            </mat-form-field>
                                        </div>
    
                                        <div class="col-7 col-xl-2 col-md-5">
                                            <mat-form-field appearance="outline">
                                                <mat-label>Contato</mat-label>
                                                <input matInput type="text" formControlName="contact" *ngIf="contactGroup.get('contactMethod')?.value === 'Email' || !contactGroup.get('contactMethod')?.value ">
                                                <input matInput type="text" formControlName="contact" [specialCharacters]="['-', '(', ')', ' ']" [mask]="'(00) 00000-0000'" 
                                                    *ngIf="contactGroup.get('contactMethod')?.value === 'WhatsApp' || contactGroup.get('contactMethod')?.value === 'Celular'">
                                                <mat-error *ngIf="contactGroup.get('contact')?.hasError('required')">
                                                    Contato é obrigatório
                                                </mat-error>
    
                                            </mat-form-field>
                                        </div>
                                        
                                        <div *ngIf="!contactGroup.get('primaryContact')?.value">
                                            <button mat-icon-button color="warn" (click)="removeContact(i)">
                                                <mat-icon>delete</mat-icon>
                                            </button>
                                        </div>
                                        <!-- <div class="col-1 d-flex align-items-center">
                                            <mat-checkbox formControlName="primaryContact">Principal</mat-checkbox>
                                        </div> -->
                                    </div>
                                </div>
    
                                <button mat-button class="btn-primary" (click)="addContact()">Novo contato</button>
                            </div>
                        </div> 
                    </div>
                    <div class="patient-case">
                        <ng-container>
                            <h3>Caso</h3>
                        </ng-container>
    
                        <div class="benefitAndInss">
                            <div class="col-12 d-flex" style="gap: 20px">
                                <div class="col-4">
                                    <mat-form-field appearance="outline"> 
                                        <mat-label>Tipo de Benefício Desejado</mat-label>
                                        <mat-select formControlName="benefitType">
                                            <mat-option
                                                *ngFor="let i of benefitType"
                                                [value]="i"
                                            >
                                            {{i}} 
                                            </mat-option>
                                        </mat-select>
                                        <mat-error *ngIf="leadForm.get('benefitType')?.hasError('required')">
                                            Esse campo é obrigatório
                                        </mat-error>
                                    </mat-form-field>
                                </div>
    
                                <div class="col-4">
                                    <mat-form-field appearance="outline" *ngIf="leadForm.value.benefitType === 'Outro'">
                                        <mat-label>Detalhes</mat-label>
                                        <textarea
                                            formControlName="benefitDescription"
                                            matInput
                                            cdkTextareaAutosize
                                            [cdkAutosizeMinRows]="1"
                                        ></textarea>
                                    </mat-form-field>
                                </div>
                            </div>
    
                            <div class="col-4">
                                <mat-form-field appearance="outline"> 
                                    <mat-label>Situação Atual no INSS</mat-label>
                                    <mat-select formControlName="inssStatus">
                                        <mat-option
                                            *ngFor="let i of inssStatus"
                                            [value]="i"
                                        >
                                        {{i}} 
                                        </mat-option>
                                    </mat-select>
    
                                    <mat-error *ngIf="leadForm.get('inssStatus')?.hasError('required')">
                                        Esse campo é obrigatório
                                    </mat-error>
                                </mat-form-field>
                            </div>
                        </div>
    
                        <div>
                            <div class="d-flex flex-column" style="margin: 10px 0 10px 0; gap: 20px">
                                <div class="col-12 d-flex" style="gap: 20px">
                                    <div class="col-lg-3 d-flex flex-column">
                                        <mat-label class="bulletLabel">O cliente possui documentos médicos atuais?</mat-label>
                                        <mat-radio-group formControlName="hasMedicalDocument" class="bulletGap">
                                            <mat-radio-button 
                                                *ngFor="let i of hasMedicalDocumentItem.hasMedicalDocument"
                                                [value]="i.value"
                                            >
                                                {{i.text}}
                                            </mat-radio-button>
                                        </mat-radio-group>
                                    </div>
            
                                    <div class="col-lg-3 d-flex flex-column" *ngIf="leadForm.value.hasMedicalDocument">
                                        <mat-label class="bulletLabel">Os documentos possuem hipótese diagnóstica ou CID?</mat-label>
                                        <mat-radio-group formControlName="documentHasCid" class="bulletGap">
                                            <mat-radio-button 
                                                *ngFor="let i of hasMedicalDocumentItem.documentHasCid"
                                                [value]="i.value"
                                            >
                                                {{i.text}}
                                            </mat-radio-button>
                                        </mat-radio-group>
                                    </div>
                                </div>
            
                                <div class="col-12 d-flex" style="gap: 20px">
                                    <div class="col-lg-3 d-flex flex-column">
                                        <mat-label class="bulletLabel">O cliente está em situação de vulnerabilidade social?</mat-label>
                                        <mat-radio-group formControlName="isBpc" class="bulletGap">
                                            <mat-radio-button 
                                                *ngFor="let i of isBpcItem.isBpc"
                                                [value]="i.value"
                                            >
                                                {{i.text}}
                                            </mat-radio-button>
                                        </mat-radio-group>
                                    </div>
            
                                    <div class="col-lg-3 d-flex flex-column" *ngIf="leadForm.value.isBpc === true">
                                        <mat-label class="bulletLabel" >Está inscrito no CadÚnico?</mat-label>
                                        <mat-radio-group formControlName="isCadUnico"  class="bulletGap">
                                            <mat-radio-button 
                                                *ngFor="let i of isBpcItem.isCadUnico"
                                                [value]="i.value"
                                            >
                                                {{i.text}}
                                            </mat-radio-button>
                                        </mat-radio-group>
                                    </div>
                                </div>
            
                                <div class="col-12 d-flex" style="gap: 20px">
                                    <div class="col-6 d-flex flex-column">
                                        <mat-label class="bulletLabel">Período de Carência</mat-label>
                                        <mat-radio-group formControlName="periodRequirement" class="bulletGap">
                                            <mat-radio-button 
                                                *ngFor="let i of periodRequirement"
                                                [value]="i.value"
                                            >
                                                {{i.text}}
                                            </mat-radio-button>
                                        </mat-radio-group>
                                    </div>
                                </div>
                            </div>
        
                            <div class="col-12">
                                <mat-form-field appearance="outline">
                                    <mat-label>Observações Internas</mat-label>
                                    <textarea
                                        formControlName="observation"
                                        matInput
                                        cdkTextareaAutosize
                                        [cdkAutosizeMinRows]="5"
                                    ></textarea>
                                </mat-form-field>
                            </div>
                        </div>
                        
                    </div>
    
                    <div class="col-12 d-flex" style="gap: 5px; justify-content: end;" >
                        <button
                            mat-button
                            (click)="goBackToCasesList()"
                        >
                            Voltar
                        </button>
                        <button
                            mat-button
                            class="btn-primary"
                            (click)="createOrUpdate()"
                            >
                            <!-- [disabled]="createOrUpdateBtnDisabled" -->
                            <span style="display: flex; align-items: center;">
                                <mat-progress-spinner 
                                    *ngIf="createOrUpdateBtnDisabled"
                                    diameter="20"
                                    mode="indeterminate"
                                    color="accent"
                                    style="margin-right: 8px;"
                                >
                                </mat-progress-spinner>
                                Salvar
                            </span>
                        </button>
                    </div>
                </form>
            </mat-card-content>
        </ng-container>

        <ng-template #loading>
            <div class="loading-case">
                <mat-spinner diameter="60" color="primary"></mat-spinner>
                <p>Carregando dados do caso...</p>
            </div>
        </ng-template>
    </mat-card>
</app-ui-main-menu>